/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {ChatInner} from '../../chat/ChatInner'
import styles from './DrawerMessage.module.css'
import {useVoiceControl} from '../../../../app/hooks/useVoiceControl'
import {useSpeechSynthesis} from '../../../../app/hooks/useSpeechSynthesis'
import {i18n} from '../../../../app/translate/i18n'

type PropsChat = {
  open: boolean
  setOpen: (value: boolean) => void
}

const DrawerMessenger: FC<PropsChat> = ({open, setOpen}) => {
  const {speak, voices, selectedVoice, setSelectedVoice} = useSpeechSynthesis()
  const [message, setMessage] = useState<string>('')
  const {isVoiceOn, toggleVoice} = useVoiceControl({
    setMessage,
  })
  const [currentView, setCurrentView] = useState<'chat' | 'about'>('chat')

  const toggleView = () => {
    setCurrentView((prev) => (prev === 'chat' ? 'about' : 'chat'))
  }

  useEffect(() => {
    if (selectedVoice) {
      console.log('Voz atual:', selectedVoice.name)
    }
  }, [selectedVoice])

  return (
    <div
      id='kt_drawer_chat'
      className={`bg-body drawer drawer-end ${open ? 'drawer-on' : ''}`}
      style={{boxShadow: '0px 0px 40px -3px rgba(0, 0, 0,0.2)'}}
      data-kt-drawer='true'
      data-kt-drawer-name='chat'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'100%', 'md': '500px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_drawer_chat_toggle'
      data-kt-drawer-close='#kt_drawer_chat_close'
    >
      <div className='card w-100 rounded-0' id='kt_drawer_chat_messenger'>
        <div
          className={`${styles.headerChat} card-header pe-5`}
          id='kt_drawer_chat_messenger_header'
        >
          <div className='card-title'>
            <div className='d-flex justify-content-center flex-column me-3'>
              <a
                href='#'
                className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'
              >
                Ninegrid IA
              </a>

              <div
                className='btn btn-sm btn-icon btn-active-light-primary position-absolute end-0 top-0'
                id='kt_drawer_chat_close'
                onClick={() => setOpen(false)}
              >
                <i className='fa fa-times fs-3'></i>
              </div>

              <div className='mb-0 lh-1 d-flex align-items-center'>
                <div className='d-flex align-items-center'>
                  <span className='badge badge-success badge-circle w-10px h-10px me-1'></span>
                  <span className='fs-7 fw-bold text-gray-400'>Online</span>
                </div>

                <div className={`${styles.controlsContainer} ms-auto`}>
                  <button
                    id='voiceToggleBtn'
                    className={`btn btn-icon ${styles.transparentButton} ${
                      isVoiceOn ? 'active' : ''
                    }`}
                    title='Ativar/Desativar leitura por voz'
                    onClick={toggleVoice}
                  >
                    <i
                      className={`bi ${isVoiceOn ? 'bi-volume-up-fill' : 'bi-volume-mute-fill'}`}
                    ></i>
                  </button>

                  {/* <button
                    id='microphoneToggleBtn'
                    className={`btn btn-icon ${styles.transparentButton} ${isListening ? 'active' : ''}`}
                    title={isListening ? 'Parar gravação' : 'Iniciar gravação'}
                    onClick={isListening ? stopListening : handleStartListening}
                  >
                    <i className={`bi ${isListening ? 'bi-mic-fill' : 'bi-mic'}`}></i>
                  </button> */}

                  {voices.length > 0 && (
                    <select
                      className={styles.voiceSelect}
                      value={selectedVoice?.name || ''}
                      onChange={(e) => {
                        const voice = voices.find((v) => v.name === e.target.value)
                        if (voice) {
                          console.log('Mudando para voz:', voice.name)
                          setSelectedVoice(voice)
                          localStorage.setItem('preferredVoice', voice.name)

                          // Teste opcional: falar uma mensagem curta ao mudar a voz
                          const testMessage = 'Voz selecionada com sucesso'
                          speak(testMessage)
                        }
                      }}
                    >
                      {voices
                        .filter((voice) => voice.lang.toLowerCase().includes('pt'))
                        .map((voice) => (
                          <option key={voice.name} value={voice.name}>
                            {voice.name}
                          </option>
                        ))}
                    </select>
                  )}
                </div>
                <span
                  className='badge badge-light-primary fs-7 ms-2 cursor-pointer'
                  style={{cursor: 'pointer'}}
                  onClick={toggleView}
                >
                  {currentView === 'chat'
                    ? i18n.t('chat.about') || 'Sobre'
                    : i18n.t('chat.chatia') || 'Chat'}
                </span>
              </div>
            </div>
          </div>
          {/* <div className='card-toolbar'>
            <div className='btn btn-sm btn-icon btn-active-light-primary' id='kt_drawer_chat_close' onClick={() => setOpen(false)}>
              <i className='fa fa-times fs-3'></i>
            </div>
          </div> */}
        </div>

        <ChatInner
          isDrawer={true}
          message={message}
          setMessage={setMessage}
          isVoiceOn={isVoiceOn}
          speak={speak}
          currentView={currentView}
          toggleVoice={toggleVoice}
        />
      </div>
    </div>
  )
}

export {DrawerMessenger}
